import React from 'react';
import ReactDOM from 'react-dom';
import './Layout.css';

// Used for page transitions and whenever the application is waiting for the data to load or save.
// It is bound to the root element.
export default function LoadingIndicator() {
    return ReactDOM.createPortal(
            <div className="loader-overlay">
                <div className="modal-bg"></div>
                <i className="fa fa-spinner fa-spin fa-3x" aria-hidden="true"></i>
            </div>,
        document.getElementById('root')
    )
}
